import { FDSelectInput } from '@facet-wealth/design';
import React, { useMemo } from 'react';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import PropTypes from 'prop-types';

export const TaxYearOptionsDropdown = ({ resource }) => {
  const { displayErrorMessage } = useSnackbarContext();
  const { loadPageContentLink } = usePageContentContext();

  const handleSelectYear = async (id) => {
    try {
      const selectedTaxOption = resource.attr('taxYearOptions').resources().findItem((tyo) => tyo.id() === id);
      await selectedTaxOption.withRelationship(fr.relationships.taxDiagnosticMemberWizard.name,
        (rel) => loadPageContentLink(rel.link('related')),
        () => null);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  const taxYearOptions = useMemo(() => resource.attr('taxYearOptions')?.resources().list().map((tyo) => {
    return {
      id: tyo.id(),
      prompt: tyo.attr('taxYear'),
    };
  }), [resource]);

  return (
    taxYearOptions ? (<FDSelectInput
      options={taxYearOptions}
      label={resource.meta().field('taxYearOptions').attr('prompt')}
      value={resource.id()}
      onChange={handleSelectYear}
    />) : null
  );
};

TaxYearOptionsDropdown.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
